module.exports = __webpack_public_path__ + "app/assets/fonts/glyphicons-halflings-regular.woff2?448c34a56d699c29117adc64c43affeb";


//////////////////
// WEBPACK FOOTER
// ./~/@suntransfers/st-ui/dist/styles/fonts/glyphicons-halflings-regular.woff2
// module id = 176
// module chunks = 1